import actionTypes from "../common/actionTypes";
import { DATABASE_STATUTES } from "../common/constants";

const activityLogsReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACTIVITY_LOGS:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
        data: action.payload.nextPage ? state.data : [],
      };

    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        data: [...state.data, ...action.payload],
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.FETCH_ACTIVITY_LOGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    default:
      return state;
  }
};

export default activityLogsReducer;
